import React from 'react';
import { findDOMNode } from 'react-dom';
import { isBrowser, isMobile } from "react-device-detect";
import { TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from '../../plugins/ScrollMagic';
import globals from '../../globals';

export default {

    destroy(controller) {
        controller.destroy(true);
    },

    initialise(OurTeam, Title, SubTitle) {
        if (!Title || !SubTitle) {
            return;
        }

        this.OurTeam = OurTeam;
        this.OurTeamNode = findDOMNode(OurTeam);
        this.members = OurTeam.memberRefs;

        let that = this,
            controller = new ScrollMagic.Controller(),
            tl = new TimelineLite();

        tl.fromTo(Title, 0.75, {y: -100, opacity: 0}, {y: 0, opacity: 1, ease: Power4.easeOut})
            .fromTo(SubTitle, 1, globals.getSubAnimation(SubTitle), {backgroundPositionY: "0px", ease: Elastic.easeOut.config(1, 0.4)}, 0)
            .add(() => {
                that.processTeams();
            }, 0.5);

        new ScrollMagic.Scene({
            triggerElement: '.our-team',
            reverse: false
        })
            .setTween(tl)
            .addTo(controller);

        return controller;
    },

    processTeams() {
        if (isBrowser) {
            this.animateTeam();
            //setTeamContainerHeight(); // Doesnt seem to be necessary now?
        }
    },

    animateTeam() {
        this.staffPositioning = [];
        this.activeItem = null;

        let tl = new TimelineLite(),
            middle = Math.round(this.members.length/2);

        this.members.map((item, key) => {
            item.style.display = 'block';
            let cnt = (key + 1),
                elementWidth = item.offsetWidth,
                halfWidth = elementWidth / 2,
                posLeft = 0;

            if (cnt === 1) {
                posLeft = Math.abs((cnt - 1) * halfWidth);
            } else {
                posLeft = Math.abs((cnt - 1) * (elementWidth + (elementWidth / 4)));
            }

            this.staffPositioning[cnt] = {pos: posLeft, member: item};

            if (cnt === middle) {
                item.classList.add('active');
                tl.fromTo(item, 0.5, {y: -300, opacity: 0}, {y: 0, opacity: 1, display: 'block'}, 0);
                this.activeItem = item;
            } else {
                tl.to(item, 1, {left: posLeft, opacity: 1, display: 'block', delay: 0.5}, 0.5);
                tl.to(item, 0, {top: 0}, 0);
            }
        });

        tl.fromTo(this.activeItem.getElementsByClassName('text'), 0.5, {opacity: 0, y:50}, {opacity: 1, y: 0}, '-=1');
        tl.fromTo(this.activeItem, 0.5, {borderColor: '#FFFFFF'}, {borderColor: '#004346'}, '-=1');
    },
    
    switchTeamMember(event) {
        let newMember = event.currentTarget,
            pos = parseFloat(newMember.dataset.pos),
            posDistance = this.staffPositioning[2].pos, // Position 2 reveals the distance between elements
            moveToPosition = this.moveTo(pos, posDistance);

        if (newMember.classList.contains('active')) {
            return;
        }
        
        this.tl = new TimelineLite();

        this.staffPositioning.map(item => {
            this.tl.to(item.member, 0.5, {left: (item.pos + moveToPosition), ease: Power4.easeOut}, 0);
        });

        this.intoFocus(newMember);
        this.outOfFocus(this.activeItem);
    },

    intoFocus(newMember) {
        this.tl.to(newMember, 0.5, {top: '-150px'}, 0.3);
        this.tl.fromTo(newMember.getElementsByClassName('text'), 0.5, {y: 100, opacity: 0}, {opacity: 1, y: 0, visibility: 'visible'}, 0.3, 0);
        this.tl.to(newMember, 0.2, {
            onComplete: () => {
                newMember.classList.add('active');
                this.activeItem = newMember;
            }}, 0.5);
    },

    outOfFocus(oldMember) {
        this.tl.to(oldMember, 0.5, {top: '0px'}, 0.3);
        this.tl.to(oldMember.getElementsByClassName('text'), 0.5, {y: -100, opacity: 0, visibility: 'hidden'}, 0.3);
        this.tl.to(oldMember, 0.2, {
            onComplete: function(){
                oldMember.classList.remove('active');
            }}, 0.3);
    },

    moveTo(pos, posDistance) {
        if (pos === 1)
            return 2 * posDistance;

        if (pos === 2)
            return posDistance;

        if (pos === 4)
            return -Math.abs(posDistance);

        if (pos === 5)
            return -Math.abs(2 * posDistance);

        if (pos === 6)
            return -Math.abs(3 * posDistance);

        return 0;
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/OurTeam/animations.js